var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('cg-alert',_vm._b({},'cg-alert',_vm.toastItem,false),[(_vm.html)?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.toastItem.message)}})]:[_vm._v(" "+_vm._s(_vm.toastItem.message)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }